import{styled as t}from"styled-components";import{useLocalizedContents as o}from"../../../../messages/context/LocalizedContentsContext.mjs";import{dateToStr as r}from"../../../../utils/DateUtils.mjs";const e=t.span.attrs((t=>({...t,onClick:t.disabled?void 0:t.onClick})))`
  width: 18px;
  height: 16px;
  margin-top: 3px;
  margin-bottom: 3px;
  float: right;
`,n=t(e)`
  ${({disabled:t})=>t?"background: url(images/ui-icons_256x240.png); background-position: 0 -192px;":"background: url(images/add_16x16.png) no-repeat scroll left center transparent;cursor: pointer;"}
`,a=t(e)`
  ${({disabled:t})=>t?"background: url(images/ui-icons_256x240.png); background-position: -16px -192px;":"background: url(images/delete_16x16.png) no-repeat scroll left center transparent;cursor: pointer;"}
`,s=t(e)`
  background: url(images/copy_16x16.png) no-repeat scroll left center transparent;
  cursor: pointer;
`;function i({date:t,type:e}){const{dateFormat:n}=o();return r(t,n[e])}export{n as AddButton,s as CopyButton,i as DateFormatter,a as DeleteButton};
